<po-table
  p-sort
  p-striped
  [p-items]="items | vulnerabilitiesDetail"
  [p-columns]="columns"
  [p-loading]="loading"
  [p-hide-table-search]="false"
  (p-sort-by)="onSort($event)"
>
  <ng-template
    p-table-row-template
    let-row
    let-i="rowIndex"
    [p-table-row-template-show]="false"
  >
    <app-dependency-track-vulnerabilities-table-detail [vulnerability]="row" />
  </ng-template>
</po-table>
